<div class="d-flex flex-column h-100">
    <ca-sidebar-nav-header
        *ngIf="isLoggedIn"
        [userInfo]="userInfo"
        [isNavbarOpen]="isNavbarOpen"
        [isLoggedIn]="isLoggedIn"
        (onLogin)="login()"
        (onLogout)="logout()"
    >
    </ca-sidebar-nav-header>
    <ca-sidebar-mobile-logged-out-nav *ngIf="isSmallDevice && !isLoggedIn"></ca-sidebar-mobile-logged-out-nav>
    <div class="navigation-content" *ngIf="isLoggedIn">
        <ul class="navbar-vertical">
            <ng-container *ngFor="let submenu of homeSubmenu"
                ><ca-sidebar-nav-link
                    *ngIf="hasPermissions(submenu.requiredPermissions)"
                    [link]="submenu.link"
                    [tooltip]="submenu.tooltip$ | async"
                    [linkName]="submenu.linkName$ | async"
                    [iconName]="submenu.iconName"
                    highlightMode="fill"
                    [isNavbarOpen]="isNavbarOpen"
                    attr.data-uit="{{ submenu.dataUit }}"
                ></ca-sidebar-nav-link
            ></ng-container>
        </ul>
        <div *ngFor="let menu of mainMenu" class="accordion-flush">
            <div ngbAccordion #accordion="ngbAccordion" class="accordion-flush" [closeOthers]="false" (panelChange)="refreshExpandedPanels($event)">
                <div ngbAccordionItem="menu.dataUit" [collapsed]="false" *ngIf="hasPermissions(menu.requiredPermissions)" id="{{ menu.id }}">
                    <h2
                        ngbAccordionHeader
                        *ngrxLet="menu.title$ as menuTitle"
                        class="group-link d-flex align-items-center my-custom-header"
                        attr.aria-label="{{ menuTitle }}"
                        [ngClass]="{ collapsed: !accordion.isExpanded(menu.id) }"
                        attr.data-uit="{{ menu.dataUit }}"
                    >
                        <button ngbAccordionButton class="font-s text-uppercase">{{ menu.title$ | async }}</button>
                    </h2>
                    <div ngbAccordionCollapse attr.data-uit="{{ menu.dataUit + '.div' }}">
                        <ul class="navbar-vertical">
                            <div ngbAccordionBody class="navbar-vertical" *ngFor="let submenu of menu.submenu">
                                <ng-template>
                                    <ca-sidebar-nav-link
                                        *ngIf="(submenu.restriction != null ? submenu.restriction : true) && hasPermissions(submenu.requiredPermissions)"
                                        linkName="{{ submenu.linkName$ | async }} {{ submenu.count$ ? '(' + (submenu.count$ | async) + ')' : '' }}"
                                        highlightMode="fill"
                                        class="sidebar-nav-link-cursor"
                                        attr.data-uit="{{ submenu.dataUit }}"
                                        [isNavbarOpen]="isNavbarOpen"
                                        [iconName]="submenu.iconName"
                                        [iconName2]="submenu.iconName2"
                                        [link]="submenu.link"
                                        [externalLink]="submenu.externalLink"
                                        [tooltip]="submenu.tooltip$ | async"
                                    ></ca-sidebar-nav-link>
                                </ng-template>
                            </div>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
